import { useSelector } from 'react-redux';
import { isBaseSubscription } from 'reactApp/modules/billingData/billingData.types';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import type { RootState } from 'reactApp/store';
import type { Subscription } from 'reactApp/ui/Mobile/SubscriptionsModal/SubscriptionsModal.types';
import { isYear2Period } from 'reactApp/utils/Period';

export const renderSubscriptionInfoModal = (data: {
    subscription: Subscription;
    isRebrandingQuotaLanding?: boolean;
    isRebranding?: boolean;
}) => openPopupHelper({ popupName: popupNames.SUBSCRIPTION_INFO_MOBILE, data });

export const useCanCheckDiscounts = (subscription: Subscription) => {
    const product = useSelector((state: RootState) => ProductsSelectors.getProductById(state, subscription?.['productId']));

    if (isBaseSubscription(subscription)) {
        return false;
    }

    const { renewable } = subscription;
    return product && renewable && !isYear2Period(product.period);
};
